import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/logos/logo-full.svg';

const DesireLogo = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
DesireLogo.defaultProps = {
    className: '',
};

export default DesireLogo;
